import { render } from "./DaftarEnvironmental.vue?vue&type=template&id=dc2bedfe"
import script from "./DaftarEnvironmental.vue?vue&type=script&lang=js"
export * from "./DaftarEnvironmental.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__